<template>
    <v-container fluid class="pa-0">
    <v-select :items="typeListByGroup['QIZ']" item-text="typ_name" item-value="typ_id" outlined dense
        v-model="qizTypId" label="Type de champ" >
    </v-select>
    <draggable
        :list="itemsTree"
        :group="{ name: 'quiz-tree', pull: true, put: true }"
        :options="{ handle: '.drag-handle', emptyInsertThreshold: 80 }"
        @change="onRootChange"
        class="quiz-tree-root"
        ghost-class="drag-ghost"
    >
        <DraggableTreeItem
            v-for="item in itemsTree"
            :key="item.qiz_id"
            :item="item"
            :type-list-by-id="typeListById"
            @change="onItemChange"
            @toggle-state="updateState"
        />
    </draggable>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'
import draggable from 'vuedraggable'
import DraggableTreeItem from './DraggableTreeItem.vue'

export default {
    name: 'quizzes-list',
    components: { draggable, DraggableTreeItem },
    computed: {
        ...mapState(useQuizStore, {itemList: 'itemList' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            qizTypId: 'QIZ01',
            headers: [
                { text: 'Nom',    value: 'qiz_name', align: 'left'},
                { text: 'Type',   value: 'qiz_typ_id', align: 'left'},
                { text: 'Action', value: 'qiz_id', align: 'right'},
            ],
            itemsTree: [],
        }
    },
    async mounted () {
        await this.fetchItems('?per_page=false')
        this.itemsTree = this.list_to_tree(this.itemList)
    },
    methods: {
        ...mapActions(useQuizStore, {fetchItems: 'fetchItems', updateItem: 'updateItem'}),
        list_to_tree(list) {
            var map = {}, node, roots = [], i;
            
            for (i = 0; i < list.length; i += 1) {
                map[list[i].qiz_id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }
            
            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.qiz_id_parent) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.qiz_id_parent]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        },
        async updateState(item){
            item.qiz_visibility = (item.qiz_visibility) ? 0 : 1
            await this.updateItem(item)
            await this.fetchItems('?per_page=false')
            this.itemsTree = this.list_to_tree(this.itemList)
        },
        onRootChange(evt) {
            this.handleChange(null, evt)
        },
        onItemChange({ parent, event }) {
            this.handleChange(parent, event)
        },
        async handleChange(parent, evt) {
            if (evt.added) {
                const item = evt.added.element
                const newParentId = parent ? parent.qiz_id : null
                if (item.qiz_id_parent !== newParentId) {
                    item.qiz_id_parent = newParentId
                    await this.updateItem(item)
                    await this.fetchItems('?per_page=false')
                    this.itemsTree = this.list_to_tree(this.itemList)
                }
            }
        }
    },
}
</script>

<style scoped>
.quiz-tree-root {
    min-height: 20px;
}
</style>